<template>
  <div style="width:100%;float:left;">
    <CCard v-if="ccs && ccs.length" style="width:100%;float:left;">
      <CCardHeader @click="collapsed = !collapsed">
        Linked Workflow CCs
        <div class="card-header-actions">
          <CLink class="card-header-action btn-minimize">
            <CIcon :name="`cil-chevron-${collapsed ? 'bottom' : 'top'}`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="collapsed" :duration="400">
        <CCardBody>
          <div style="width:100%;float:left;">
            <table class="table">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Form#</th>
                </tr>
              </thead>
              <tbody v-for="val in ccs">
                <tr v-for="v in val.nums">
                  <td>{{val.label}}</td>
                  <td>
                    <a v-if="val.type === 'escape'" target="_blank" :href="'https://paiworkflow.com/#/task/' + val.type + '/' + v.form_num">{{v.form_num}}</a>
                    <a v-if="val.type === 'artpack'" target="_blank" :href="'https://paiworkflow.com/#/task/' + val.type + '/' + v.form_num">{{v.form_num}}</a>
                    <a v-if="val.type === 'vulcan'" target="_blank" :href="'https://paiworkflow.com/#/task/' + val.type + '/' + v.form_num">{{v.form_num}}</a>
                    <a v-if="val.type === 'order_entry'" target="_blank" :href="'https://paiworkflow.com/#/task/' + val.type + '/' + v.form_num">{{v.form_num}}</a>
                    <a v-if="val.type === 'embroidery'" target="_blank" :href="'https://paiworkflow.com/#/task/' + val.type + '/' + v.form_num">{{v.form_num}}</a>
                    <a v-if="val.type === 'component'" target="_blank" :href="'https://paiworkflow.com/#/task/' + val.type + '/' + v.component_id">{{v.form_num}}</a>
                    <a v-if="val.type === 'heat_seal'" target="_blank" :href="'https://paiworkflow.com/#/task/' + val.type + '/' + v.heat_id">{{v.form_num}}</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CCardBody>
      </CCollapse>
    </CCard>
  </div>
</template>
<script>
var methods = {}

methods.getCCs = function () {
  const postData = {
    group: this.group
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/flow/getCCs?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.ccs = response.data
  })
}

export default {
  // ===Component name
  name: "OrderCc",
  // ===Props passed to component
  props: ['group'],
  // ===Components used by this component
  components: {

  },
  // ====component Data properties
  data(){
      return{
        ccs: null,
        collapsed: false
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    this.getCCs()
  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
